import React from "react";
import "./index.css";

const formatBytes = (value) => {
  const bytes = Number(value);

  if (!Number.isFinite(bytes) || bytes < 0) return "Indisponivel";
  if (bytes < 1024) return `${bytes} B`;

  const units = ["KB", "MB", "GB", "TB"];
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length,
  );
  const amount = bytes / 1024 ** exponent;

  return `${amount.toLocaleString("pt-BR", {
    maximumFractionDigits: amount >= 10 ? 0 : 1,
  })} ${units[exponent - 1]}`;
};

const formatPercentage = (value) => {
  const percentage = Number(value);

  if (!Number.isFinite(percentage) || percentage < 0) return "Indisponivel";

  return `${percentage.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })}%`;
};

function LocalStorageCapacity({ capacity, className = "" }) {
  if (!capacity?.applicable) return null;

  if (capacity.status === "UNAVAILABLE") {
    return (
      <section
        className={`local-storage-capacity unavailable ${className}`.trim()}
        aria-label="Capacidade local"
        role="status"
      >
        <h2>Capacidade local</h2>
        <p>Capacidade local indisponivel.</p>
      </section>
    );
  }

  const isLow = capacity.status === "LOW";

  return (
    <section
      className={`local-storage-capacity ${isLow ? "low" : "ok"} ${className}`.trim()}
      aria-label="Capacidade local"
    >
      <h2>Capacidade local</h2>
      <dl>
        <div>
          <dt>Total</dt>
          <dd>{formatBytes(capacity.totalBytes)}</dd>
        </div>
        <div>
          <dt>Livre</dt>
          <dd>{formatBytes(capacity.freeBytes)}</dd>
        </div>
        <div>
          <dt>Percentual livre</dt>
          <dd>{formatPercentage(capacity.freePercentage)}</dd>
        </div>
      </dl>

      {isLow ? (
        <p className="local-storage-capacity-alert" role="alert">
          O espaco local esta abaixo de 20%. Libere ou amplie o espaco antes de novos envios.
        </p>
      ) : null}
    </section>
  );
}

export default LocalStorageCapacity;
